import axios from "axios";
import { AppThunk } from "@Store/index";
import {
  getPlusPageRequesting,
  getPlusPageSuccess,
  getPlusPageFailure,
} from "./amberPlusPageReducer";
import { getMetaSuccess } from "@App/appReducer";
import config from "@Config/index";

const getCmsUrl = (path: string) =>
  __CLIENT__
    ? `${window.location.origin}/proxy/${config.CMS_API_URL}${path}`
    : `${config.CMS_API_URL}${path}`;

const toImg = (img: any) => (img ? { fileId: "", url: img.url ?? "", alt: img.alt ?? null } : null);

const fetchPlusPageData =
  ({ url }: any): AppThunk =>
  async (dispatch) => {
    dispatch(getPlusPageRequesting());
    try {
      const res = await axios.get(getCmsUrl("/api/amberplus-page/homepage"));
      const { featured = [], bestDeals = [], partners = [], categories = [] } = res.data;

      dispatch(
        getPlusPageSuccess({
          data: {
            featured_images: featured.map((item: any, idx: number) => ({
              id: `featured-${idx}`,
              fieldData: {
                title: item.title ?? "",
                subtitle: item.subtitle ?? "",
                "cta-text": item.ctaText ?? "",
                backgroundcolor: item.backgroundColor ?? "",
                "web-featured-image": toImg(item.desktopImage),
                "image-source": toImg(item.desktopImage),
                "mobile-featured-image": toImg(item.mobileImage),
                "mobile-image": toImg(item.mobileImage),
                logo: toImg(item.partnerLogo),
                "mobile-logo": toImg(item.partnerLogo),
                "partner-redirect-link": item.redirectLink ?? "",
              },
            })),
            best_deals: bestDeals.map((item: any) => ({
              id: String(item.id),
              fieldData: {
                heading: item.title ?? "",
                "sub-heading": item.subtitle ?? "",
                "patrner-hero-image": toImg(item.image) ?? { url: "", alt: "" },
                "partner-image": toImg(item.partnerLogo),
                "partner-link": item.redirectLink ?? "",
                "offer-code": item.offerCode ?? "",
                "has-offer-code": item.hasOfferCode ?? false,
                "offer-text": item.offerText ?? "",
                "discount-text": item.discountText ?? "",
              },
            })),
            partners: partners.map((p: any) => ({
              id: String(p.id),
              fieldData: {
                name: p.name ?? "",
                "partner-image": toImg(p.logo),
              },
            })),
            services: categories.map((c: any) => ({
              id: String(c.id),
              fieldData: {
                name: c.name ?? "",
                slug: c.slug ?? "",
                logo: toImg(c.logo),
              },
            })),
          },
        }),
      );

      const meta: any = {
        title_prefix: "Explore Student Services With Benefits And Perks With Amber+",
        description:
          "Unlock Student Benefits at Amber Plus! Explore Student Services & Boost Your Potential. Expert Assistance for Flight Bookings, Guarantor Support & More. Student Discounts Available!",
        url,
        canonical_url_suffix: url,
      };
      dispatch(getMetaSuccess(meta));
      return null;
    } catch (err: any) {
      return dispatch(getPlusPageFailure(err));
    }
  };

export default fetchPlusPageData;
